import React from 'react';
import SurfaceTabs from './SurfaceTabs';

function PlayerComparison({ 
  selected1, 
  selected2, 
  comparisonResults, 
  isCalculating, 
  renderConfidence,
  getAiSummary,
  setAiSummary
}) {
  if (!selected1 || !selected2) {
    return null;
  }
  
  return (
    <div>
      <h3 style={{textAlign: "center"}}>Résultats</h3>
      
      {/* Probabilités par surface */}
      {isCalculating ? (
        <div style={{textAlign: 'center', padding: '20px'}}>
          <p>Calcul des probabilités avancées en cours...</p>
        </div>
      ) : (
        <div style={{marginTop: 20}}>
          {/* Surface Tabs */}
          {comparisonResults && (
            <SurfaceTabs 
              selected1={selected1}
              selected2={selected2}
              comparisonResults={comparisonResults}
              renderConfidence={renderConfidence}
              getAiSummary={getAiSummary}
              setAiSummary={setAiSummary}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default PlayerComparison; 